export const CRM_ASSETS_RELATIVE_PATH = "assets/vectors/crm";

export const ADD_CUSTOMER_FORM_KEYS = {
  selected_price: "selected_price",
  installments: "installments",
  send_installment_comms: "send_installment_comms",
  currency: "currency",
  payment_type: "payment_type",
  customer_phone_number: "customer_phone_number",
  country_code: "country_code",
  country: "country",
  note: "note",
  payment_mode_uuid: "payment_mode_uuid",
  gateway_transaction_id: "gateway_transaction_id",
  customer_gst_details: "customer_gst_details",
  gst_number: "gst_number",
  gst_name: "gst_name",
  billing_state: "billing_state",
  tag_uuids: "tag_uuids",
  tag_name: "tag_name",
  payment_mode_name: "payment_mode_name",
  customer_timezone: "customer_timezone",
  booking_start_date: "booking_start_date",
  address_details: "address_details",
  full_name: "full_name",
  email: "email",
  phone: "phone",
};

export const TABLE_ACTIONS_IDS = {
  NOTE: "note",
  TAG: "tag",
};

export const CREATED_AT = "created_at";

export const others = "Others";
export const listing_answer_count = "Answer Count";
export const see_responses_link_text = "See Responses";
export const last_div_id = "scrollDiv";

export const INITIAL_PAGE = 1;
export const DEFAULT_SCROLL_HEIGHT = 0;
export const SCROLL_HEIGHT_OFFSET = 400;
export const SCROLL_TOP_OFFSET = 100;
export const SCROLL_TO_ROW_DELAY = 1000;
export const SCROLL_TOLERANCE = -15;

export const LEAD_REASONS_KEYS = {
  LISTING_GET_IN_TOUCH: 0,
  GET_IN_TOUCH: 1,
  LISTING_EXIT_INTENT: 2,
  EXIT_INTENT: 3,
  PAYMENT_FAILED: 4,
  PAYMENT_PENDING: 5,
  DEMO_PAYMENT: 6,
  PAYMENT_DONE: 7,
  IMPORTED_LEAD: 8,
  BLOG_SUBSCRIBER_LEAD: 9,
  IVR_PAYMENT_LINK_SENT: 10,
  IVR_REQUESTED_CALLBACK: 11,
  IVR_NO_RESPONSE: 12,
  MOBILE_APP_REGISTRATION: 13,
  DIRECT_WA_MESSAGE: 14,
  DIRECT_EMAIL: 15,
};

export const LEAD_REASONS_STRINGS = {
  [LEAD_REASONS_KEYS.LISTING_GET_IN_TOUCH]: "Interested in an offering",
  [LEAD_REASONS_KEYS.GET_IN_TOUCH]: "Requested to be contacted",
  [LEAD_REASONS_KEYS.LISTING_EXIT_INTENT]: "Viewed an offering",
  [LEAD_REASONS_KEYS.EXIT_INTENT]: "Viewed an offering",
  [LEAD_REASONS_KEYS.PAYMENT_FAILED]: "Payment Failed",
  [LEAD_REASONS_KEYS.PAYMENT_PENDING]: "Payment Initiated",
  [LEAD_REASONS_KEYS.DEMO_PAYMENT]: "Demo Payment",
  [LEAD_REASONS_KEYS.PAYMENT_DONE]: "Payment Done",
  [LEAD_REASONS_KEYS.IMPORTED_LEAD]: "Imported leads",
  [LEAD_REASONS_KEYS.BLOG_SUBSCRIBER_LEAD]: "Blog Subscriber leads",
  [LEAD_REASONS_KEYS.IVR_PAYMENT_LINK_SENT]: "IVR Payment Link Sent",
  [LEAD_REASONS_KEYS.IVR_REQUESTED_CALLBACK]: "IVR Requested Callback",
  [LEAD_REASONS_KEYS.IVR_NO_RESPONSE]: "IVR No Response",
  [LEAD_REASONS_KEYS.MOBILE_APP_REGISTRATION]: "Mobile App Registration",
  [LEAD_REASONS_KEYS.DIRECT_WA_MESSAGE]: "Direct Whatsapp Message",
  [LEAD_REASONS_KEYS.DIRECT_EMAIL]: "Direct Email",
};
